import { ReactNode } from "react";

type BottomConfirmBarProps = {
  label: ReactNode;
  disabled?: boolean;
  disabledHint?: ReactNode;
  onClick: () => void;
  note?: ReactNode;
  className?: string;
};

export const BottomConfirmBar = ({
  label,
  disabled = false,
  disabledHint,
  onClick,
  note,
  className
}: BottomConfirmBarProps) => {
  return (
    <footer className={`bottom-confirm-bar${className ? ` ${className}` : ""}`}>
      {disabled && disabledHint ? <p className="bottom-confirm-hint">{disabledHint}</p> : null}
      <button type="button" className="primary-button" disabled={disabled} onClick={onClick}>
        {label}
      </button>
      {note ? <p className="bottom-confirm-note">{note}</p> : null}
    </footer>
  );
};
